import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AiProviderConnectionTestFailedAction = {
	type: 'AI_PROVIDER_CONNECTION_TEST_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AiProviderConnectionTestFailedAction => ({
	type: 'AI_PROVIDER_CONNECTION_TEST_FAILED',
	payload,
});
